import { useCallback, useMemo } from 'react';
import { types as ats } from '../../../actions';
import { TOTAL_PAGE_SIZE, FILE_HEIGHT, GRID_TYPES, getTopSection, renderGridItem, loadMoreItems } from './shared';

const { LOAD_NAVIGATION_FILES, LOAD_SEARCH_FILES } = ats;

export default (props) => {
  const {
    files,
    selectedFiles,
    filesIsInit,
    filesCursor,
    folderLoadingIsDone,
    filesIsPending,
    term,
    folderId,
    folderPath,
    folderKind,
    folderDriveId,
    orderBy,
    sort,
    actions,
    isMultiple,
  } = props;

  const isFileLoaded = useCallback((index) => !!files[index], [files]);

  const totalFiles = files.length + ((filesCursor || filesIsInit) && folderLoadingIsDone ? TOTAL_PAGE_SIZE : 0);

  const loadMore = useCallback(() => {
    const action = actions[term ? LOAD_SEARCH_FILES : LOAD_NAVIGATION_FILES];
    return loadMoreItems(action, filesIsPending, filesCursor, {
      term,
      sort,
      orderBy,
      folderId,
      folderPath,
      folderKind,
      folderDriveId,
    });
  }, [actions, term, folderId, folderPath, folderKind, folderDriveId, sort, orderBy, filesIsPending, filesCursor]);

  const filesSection = useMemo(
    () => ({
      top: getTopSection(GRID_TYPES.FILES, files, totalFiles),
      itemHeight: FILE_HEIGHT,
      totalItems: totalFiles,
      renderItemComponent: renderGridItem,
      isItemLoaded: isFileLoaded,
      loadMore,
      // we pass selectedFiles so selection of item causes re-render of the selected or unselected item
      items: selectedFiles,
      itemProps: {
        type: GRID_TYPES.FILES,
        items: files,
        selected: selectedFiles,
        total: totalFiles,
        isMultiple,
      },
    }),
    [totalFiles, files, selectedFiles, isFileLoaded, loadMore, isMultiple]
  );

  return filesSection;
};
